import { ErrorBoundaryProps, ErrorBoundary } from '@sentry/react';
import { Outlet } from 'react-router';
import { handleError } from '../../blocks/Error';
import Footer from '../../blocks/Footer';
import runtime from '@/runtime';

const beforeCapture: ErrorBoundaryProps['beforeCapture'] = scope => {
    scope.setTag('boundary', 'CenteredLayout');
};

const CenteredLayout = () => (
    <div className="flex h-screen flex-col">
        <div className="flex flex-1 items-center justify-center">
            <ErrorBoundary beforeCapture={beforeCapture} fallback={handleError}>
                <Outlet />
            </ErrorBoundary>
        </div>
        <Footer appName={runtime.organization?.legalName || runtime.appName} version={runtime.appVersion} />
    </div>
);

export default CenteredLayout;
